import { Button } from '@harvesthq/porchlight'

import { removeCredentials } from '../lib/authentication'
import { BroadcastMessageType, broadcastMessage } from '../lib/broadcastMessage'
import { signInUrl } from '../lib/urls'
import { switchOrSelectAccount, localStorageEnabled } from '../lib/util'

const { VITE_GETHARVEST_HOST: GETHARVEST_HOST } = import.meta.env

const viaSaml =
  (localStorageEnabled && localStorage.getItem('via_saml')) || null
const updatedSignInUrl = new URL(signInUrl)
updatedSignInUrl.searchParams.append('via_saml', viaSaml)
updatedSignInUrl.toString()

const getSignupUri = () => {
  const query = new URLSearchParams({ utm_source: 'WebPlatform' })

  const currentService = new URLSearchParams(window.location.search).get(
    'service'
  )
  if (currentService) {
    query.set('utm_medium', currentService)
  }

  const returnTo = new URLSearchParams(window.location.search).get('return_to')

  if (returnTo) {
    const service = new URLSearchParams(returnTo.split('?')[1]).get('service')

    if (service) {
      query.set('utm_medium', service)
      if (service === 'app.asana.com') {
        query.set('return_to', '/asana/connect')
      }
    }
  }

  return `//${GETHARVEST_HOST}/signup?${query}`
}

const close = () => {
  broadcastMessage({ type: BroadcastMessageType.FrameClose, crossOrigin: true })
}

export const SignIn = () => {
  removeCredentials()
  const signupUri = getSignupUri()

  return (
    <div className="pds-p-md">
      <h3>Select an account</h3>

      <p>
        You need to select a Harvest account. If you’re not signed in, you’ll be
        prompted to sign in before making a selection.
      </p>

      <Button
        className="pds-mr-xs"
        label="Select an account"
        onClick={() => switchOrSelectAccount(updatedSignInUrl)}
        variant="primary"
      />

      <Button label="Cancel" variant="cancel" onClick={close} />

      <p className="pds-color-gray pds-pt-sm">
        If you don’t have an account yet,{' '}
        <a href={signupUri} target="_blank" rel="noopener">
          try Harvest free now
        </a>
        .
      </p>
    </div>
  )
}
